export function padLeft(str: string, length = 2, pad = "0") {
	while (str.length < length) { str = pad + str; }
	return str;
}
